const KeyCodes = {
    ENTER: 13
};

export { KeyCodes };
